import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import ProductCard from "@/components/public/ProductCard";

export default function Catalogue() {
  const [params, setParams] = useSearchParams();
  const [cats, setCats] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const category = params.get("category") || "All";
  const q = params.get("q") || "";
  const [search, setSearch] = useState(q);

  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);

  useEffect(() => {
    setLoading(true);
    const qs = new URLSearchParams();
    if (category && category !== "All") qs.set("category", category);
    if (q) qs.set("search", q);
    api.get(`/products?${qs.toString()}`).then((r) => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [category, q]);

  const setCategory = (c) => {
    const next = new URLSearchParams(params);
    if (c === "All") next.delete("category"); else next.set("category", c);
    setParams(next);
  };

  const onSearch = (e) => {
    e.preventDefault();
    const next = new URLSearchParams(params);
    if (search) next.set("q", search); else next.delete("q");
    setParams(next);
  };

  const allCats = [{ name: "All" }, ...cats];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10">
      <h1 className="font-heading text-3xl sm:text-4xl font-bold">Shop Groceries</h1>
      <p className="text-muted-foreground mt-1">Fresh picks delivered from your nearest store.</p>

      <form onSubmit={onSearch} className="mt-6 relative max-w-lg">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input data-testid="catalogue-search" value={search} onChange={(e) => setSearch(e.target.value)}
          placeholder="Search products…" className="pl-9 h-11" />
      </form>

      <div className="mt-6 flex gap-2 flex-wrap">
        {allCats.map((c) => (
          <button key={c.name} data-testid={`filter-${c.name}`} onClick={() => setCategory(c.name)}
            className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${
              category === c.name ? "bg-yellow-400 text-slate-900 border-yellow-500" : "bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800 hover:border-yellow-400"
            }`}>
            {c.name}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="py-20 text-center text-muted-foreground">Loading products…</p>
      ) : products.length === 0 ? (
        <p className="py-20 text-center text-muted-foreground" data-testid="no-products">No products found.</p>
      ) : (
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
